import styled from 'styled-components';

import { BaseLandholdC } from '../../svg';

interface IProps {
    size: number;
    rotation: string;
}

export const LandholdC = styled(BaseLandholdC)<IProps>`
    width: ${(props) => `${props.size}px`};
    height: ${(props) => `${props.size}px`};
    transform: rotate(${(props) => props.rotation});
`;
